import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseCourses } from '@/api/responses/manage/academyCourses'

export namespace AcademyCoursesApi {
  /**
   * コース一覧取得(全件)
   *
   * @param options 教室IDと塾ID(どちらかは必須、両者とも未指定の場合API側でエラー発生)
   * @param options.branchId 教室ID(非必須)
   * @param options.academyId 教室ID(非必須)
   * @returns コース一覧
   */
  export async function getAll(options: {
    /** 教室ID */
    branchId?: number
    /** 塾ID */
    academyId?: number
  }): Promise<ApiResponseCourses> {
    const params = {}
    if (options.branchId) {
      Object.assign(params, { branchId: options.branchId })
    }
    if (options.academyId) {
      Object.assign(params, { academyId: options.academyId })
    }
    return await ApiBase.get('/manage/academyCourses/all', params)
  }

  /**
   * 引数の型
   */
  type OptionParams = {
    /** 学年コード */
    gradeCode?: string
    /** 教室ID */
    branchId?: number
    /** 塾ID */
    academyId?: number
  }

  /**
   * 生徒が存在するコース一覧取得
   *
   * @param options 学年コード(非必須)、教室IDと塾ID(どちらかは必須、両者とも未指定の場合API側でエラー発生)
   * @returns コース一覧
   */
  export async function getCoursesHasStudents(options: OptionParams): Promise<ApiResponseCourses> {
    const params = {
      gradeCode: options.gradeCode,
      branchId: options.branchId,
      academyId: options.academyId,
    }
    return await ApiBase.get('/manage/academyCourses', params)
  }

  /**
   * 仮生徒が存在するコース一覧取得
   *
   * @param options 学年コード(非必須)、教室IDと塾ID(どちらかは必須、両者とも未指定の場合API側でエラー発生)
   * @returns コース一覧
   */
  export async function getCoursesHasTemporaryStudents(options: OptionParams): Promise<ApiResponseCourses> {
    const params = {
      gradeCode: options.gradeCode,
      branchId: options.branchId,
      academyId: options.academyId,
    }
    return await ApiBase.get('/manage/academyCourses/temporary', params)
  }
}
